module.exports = __webpack_public_path__ + "static/media/andie-image-2.4f71483e.png";